// File: frontend/src/components/GDPRConsent/GDPRConsentWrapper.js

import React from 'react';
import { useGDPRConsent } from '../../contexts/GDPRConsentContext';
import GDPRConsentPopup from './GDPRConsentPopup';

const GDPRConsentWrapper = ({ children }) => {
  const { hasConsent, isLoading } = useGDPRConsent();

  if (isLoading) {
    // Simple loading state while checking consent status
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        background: '#121212'
      }}>
        <div style={{ width: '40px', height: '40px', border: '3px solid rgba(255,255,255,.3)', borderRadius: '50%', borderTopColor: '#0095ff', animation: 'spin 1s linear infinite' }}></div>
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (!hasConsent) {
    return <GDPRConsentPopup />;
  }

  return children;
};

export default GDPRConsentWrapper;